import React from 'react';
import { Button, Form, Input, Switch } from 'antd';

import formatName from '../formatName';

const FormItem = Form.Item;

export class ListForm extends React.Component {
  state = {
    nameTouched: !!this.props.name,
  }

  itemsRef = React.createRef();

  onChange = (changed, nameHasBeenTouched) => {
    const { onChange, onValid, control: prevControl } = this.props;
    const control = { ...prevControl, ...changed };
    const isValid = this.isValid(control);

    onValid(isValid);
    onChange(control);

    if (nameHasBeenTouched) {
      this.setState({ nameTouched: true });
    }
  }

  get canAdd () {
    const { control: { items = [''] } } = this.props;
    return !items.some(value => !value);
  }

  setItem = k => ({ target: { value } }) => {
    if (!value) return this.remove(k);

    const { onChange, control: { items: prevItems = [] } } = this.props;
    const items = [...prevItems];
    items[k] = value;
    return onChange({ items });
  }

  add = () => {
    const { control: { items: prevItems = [] } } = this.props;
    const items = [...prevItems, ''];
    this.onChange({ items });
    setTimeout(() => {
      const { itemsRef: { current } } = this;
      current.querySelector('li:last-child input').focus();
    });
  };

  remove (k) {
    const { control: { items: prevItems = [] } } = this.props;

    if (prevItems.length < 2) return;

    const items = [...prevItems];
    items.splice(k, 1);
    this.onChange({ items });
    setTimeout(() => {
      const { itemsRef: { current } } = this;
      const input = current.querySelector(`li:nth-child(${k + 1}) input`);
      if (input) {
        input.focus();
      }
    });
  }

  isValid (control) {
    const { controls, control: { label: prevLabel, name: prevName } } = this.props;
    const { label = prevLabel, name = prevName } = control;
    const isNameSame = name === prevName;
    const isNameValid = isNameSame || !controls.find(({ name: cName }) => cName === name);
    return label && name && isNameValid;
  }

  render () {
    const { control: { label = '', name = '', required, multiple, items = [''] } } = this.props;
    const { nameTouched } = this.state;
    const { onChange, setItem, add, canAdd, itemsRef } = this;
    const itemId = `item-${parseInt(Math.random() * 1000, 10)}`;

    return (
      <React.Fragment>
        <FormItem
          label="Libellé du champ"
          extra="Libellé qui sera indiqué au-dessus du champ texte pour indiquer à l'utilisateur le contenu attendu."
          required
        >
          <Input
            value={label}
            onChange={({ target: { value } }) => onChange({
              label: value,
              name: nameTouched ? name : formatName(value),
            })}
          />
        </FormItem>
        <FormItem
          label="Liste des propositions"
          extra="Cette liste doit contenir au moins 2 éléments.."
          required
        >
          <ul ref={itemsRef} style={{ listStyle: 'none', padding: 0 }}>
            {items.map((value, k) => (
              <li
                // eslint-disable-next-line react/no-array-index-key
                key={k}
              >
                <Input
                  id={k === 0 ? itemId : undefined}
                  value={value}
                  onChange={setItem(k)}
                />
              </li>
            ))}
          </ul>
          <Button
            disabled={!canAdd}
            onClick={add}
          >
            + Ajouter
          </Button>
        </FormItem>
        <FormItem
          label="Champ obligatoire"
        >
          <Switch
            checked={!!required}
            onChange={checked => onChange({ required: checked })}
          />
        </FormItem>
        <FormItem
          label="Permettre de choisir plusieurs propositions ?"
        >
          <Switch
            checked={!!multiple}
            onChange={checked => onChange({ multiple: checked })}
          />
        </FormItem>
        <FormItem
          label="Nom du champ"
          required
          extra="Il s'agit du nom donné en base de donnée, il ne sera donc pas visible pour l'utilisateur. Cette étiquette pourra être utilisé lors de la création de template PDF."
        >
          <Input
            value={formatName(name)}
            onChange={({ target: { value } }) => onChange({ name: formatName(value) }, true)}
          />
        </FormItem>
      </React.Fragment>
    );
  }
}

export default ListForm;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/Control/ListForm.js